import { ClickAwayListener, Grow, IconButton, MenuItem, MenuList, Paper, Popper } from '@mui/material';
import React from 'react';
import MoreIcon from '@mui/icons-material/MoreVert';

export function ActionMenu({ extractAudio, exportToV7, copy, deleteDataSet, updateDataSet, evaluateArms, evaluateFace, evaluateSpeech, uploadEvaluation, archive, restore }) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleExtractAudio = (event) => {
    handleClose(event);
    extractAudio();
  };

  const handleExportToV7 = (event) => {
    handleClose(event);
    exportToV7();
  };

  const handleCopy = (event) => {
    handleClose(event);
    copy();
  };

  const handleDelete = (event) => {
    handleClose(event);
    deleteDataSet();
  };

  const handleUpdate = (event) => {
    handleClose(event);
    updateDataSet();
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleEvaluateArms = (event) => {
    handleClose(event);
    evaluateArms();
  };

  const handleEvaluateFace = (event) => {
    handleClose(event);
    evaluateFace();
  };

  const handleEvaluateSpeech = (event) => {
    handleClose(event);
    evaluateSpeech();
  };

  const handleUploadEvaluation = (event) => {
    handleClose(event);
    uploadEvaluation();
  };

  const handleArchive = (event) => {
    handleClose(event);
    archive();
  };

  const handleRestore = (event) => {
    handleClose(event);
    restore();
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <>
      <IconButton ref={anchorRef} id="composition-button" aria-controls={open ? 'composition-menu' : undefined} aria-expanded={open ? 'true' : undefined} aria-haspopup="true" onClick={handleToggle}>
        <MoreIcon />
      </IconButton>
      <Popper open={open} anchorEl={anchorRef.current} role={undefined} placement="bottom-start" transition>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open} id="composition-menu" aria-labelledby="composition-button" onKeyDown={handleListKeyDown}>
                  <MenuItem onClick={handleExtractAudio}>Extract Audio</MenuItem>
                  <MenuItem onClick={handleExportToV7}>Export to V7</MenuItem>
                  <MenuItem onClick={handleCopy}>Copy</MenuItem>
                  <MenuItem onClick={handleDelete}>Delete</MenuItem>
                  <MenuItem onClick={handleUpdate}>Update</MenuItem>
                  <MenuItem onClick={handleArchive}>Archive</MenuItem>
                  <MenuItem onClick={handleRestore}>Restore</MenuItem>
                  <MenuItem onClick={handleEvaluateArms}>Evaluate Arms</MenuItem>
                  <MenuItem onClick={handleEvaluateSpeech}>Evaluate Speech</MenuItem>
                  <MenuItem onClick={handleEvaluateFace}>Evaluate Face</MenuItem>
                  <MenuItem onClick={handleUploadEvaluation}>Upload Evaluation</MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
